import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownProductSecondaryServices', request)
}

async function post(request) {
    return await postMethod('/api/ownProductSecondaryServices', request)
}

async function put(request) {
    return await putMethod('/api/ownProductSecondaryServices', request)
}

export {get, post, put}
